import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { Breakpoint, ScreenSize } from '@lyceo/shared/util-models';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private readonly breakpointObserver: BreakpointObserver =
    inject(BreakpointObserver);

  public breakPoint$: Observable<BreakpointState> =
    this.breakpointObserver.observe([
      Breakpoint.XS,
      Breakpoint.SM,
      Breakpoint.MD,
      Breakpoint.LG,
      Breakpoint.XL,
    ]);

  public getScreenSize(breakpointState: BreakpointState): ScreenSize {
    if (breakpointState.breakpoints[Breakpoint.XS]) {
      return ScreenSize.XS;
    }

    if (breakpointState.breakpoints[Breakpoint.SM]) {
      return ScreenSize.SM;
    }

    if (breakpointState.breakpoints[Breakpoint.MD]) {
      return ScreenSize.MD;
    }

    if (breakpointState.breakpoints[Breakpoint.LG]) {
      return ScreenSize.LG;
    }

    if (breakpointState.breakpoints[Breakpoint.XL]) {
      return ScreenSize.XL;
    }

    return ScreenSize.XS;
  }
}
